const popups = () => {
	// COVID-19 Popup
	if ($('body.home .popup').data('show-covid-popup') == 'yes') {
		openPopup('covid-19');
		var tl;
		tl = gsap.timeline();
		tl.to('.popup', { duration: 0.4, opacity: 1 });
		tl.from('.popup__header .js__popup-close, .popup__header-image', {
			duration: 0.4,
			opacity: 0,
		});
		tl.from('.popup__booking-header', { duration: 0.4, y: 20, opacity: 0 });
		tl.from(
			'.popup__booking-content p',
			{ duration: 0.6, y: 30, opacity: 0, stagger: 0.1 },
			'-=0.2'
		);
	}

	$('.popup').addClass('loaded');

	// Menu Popup
	$(document).on('click', '.js__nav-trigger', function (e) {
		e.preventDefault();

		//Target Popup
		var popup = $(this).data('popup');

		if (!$(this).hasClass('active')) {
			openPopup(popup);
			openNavPopupAnimation();
		} else {
			closePopupAnimation();
		}

		if ($(window).width() < 575) {
			$(this).toggleClass('active');
		}
	});

	// Booking Popup
	$(document).on('click', '.js__booking-trigger, .booking-button', function (e) {
		e.preventDefault();
		var bookingButton = $('header .resy__button >span');
		bookingButton.trigger('click');
	});

	$(document).on('click', '.js__vacancies-link, .vacancies-link', function (e) {
		e.preventDefault();
		var popup = 'vacancies';

		openPopup(popup);
		openVacanciesPopupAnimation();
	});

	$('.js__popup-close').on('click', function (e) {
		e.preventDefault();

		closePopupAnimation();
	});

	$(document).keyup(function (e) {
		if (e.keyCode === 27) {
			// esc
			if ($('.popup').hasClass('open')) {
				closePopupAnimation();
				$('.js__nav-trigger').removeClass('active');
			}
		}
	});
};

const openPopup = (popup) => {
	$('.popup').removeClass('peakpop');

	//Close any already open popups
	$('.popup').removeClass('open');
	$('.popup').removeClass('showing');
	
	if (popup == 'nav') {
		$('.popup').addClass('nav-popup');
	}
	if (popup == 'covid-19') {
		$('.popup').addClass('peakpop');
	}

	$('.popup .popup__item').removeClass('showing');
	$('.popup .popup__header-image').show();
	$('.popup .popup__header .js__popup-close').show();
	$('html, body').css('overflow', 'hidden');

	$('.popup').addClass('open');
	$('.popup .popup__item#' + popup).addClass('open showing');
};

const closePopup = () => {
	if ($('.popup__item#covid-19').hasClass('open')) {
		setCookie('covid-19-popup', 'popup_closed');
	}

	$('.js__nav-trigger').removeClass('active');
	$('.popup__item-nav-line').removeClass('animate');

	$('.popup').removeClass('open');
	$('.popup').removeClass('nav-popup');
	$('.popup .popup__item').removeClass('open');

	$('html, body').removeAttr('style');
};
